export default [
    {
        path: '/commonSimple',
        component: () => import('@/views/kl/screen/common/simple/common-simple.vue'),
        hidden: true,
        name: "commonSimple",
        meta: { title: '简单首页', dictType: "common_simple", affix: false }
    },
    {
        path: '/simpleCustom',
        component: () => import('@/views/kl/screen/common/simple/simple-custom.vue'),
        hidden: true,
        name: "simpleCustom",
        meta: { title: '简单定制大屏', dictType: "common_simpleCustom", affix: false }
    },
    {
        path: '/multi-entity',
        component: () => import('@/views/kl/screen/common/simple/multi-entity.vue'),
        hidden: true,
        name: "multi-entity",
        meta: { title: '多实体大屏', dictType: "common_multiEntity", affix: false }
    },
    {
        path: '/simpleLoadCarrying',
        component: () => import('@/views/kl/screen/common/simple/simple-load-carrying.vue'),
        hidden: true,
        name: "simpleLoadCarrying",
        meta: { title: '简单承载量屏幕类型', dictType: "common_loadCarrying", affix: false }
    },
    {
        path: '/mainBranchLibrary',
        component: () => import('@/views/kl/screen/common/mainBranchLibrary/mainBranchLibrary.vue'),
        hidden: true,
        name: "mainBranchLibrary",
        meta: { title: '总分馆客流大数据平台', dictType: "common_MainBranchLibrary", affix: false }
    },
    {
        path: '/vrTemplate',
        component: () => import('@/views/kl/screen/common/vrTemplate/vr-template.vue'),
        hidden: true,
        name: "vrTemplate",
        meta: { title: 'vr模板', dictType: "vrTemplate", affix: false }
    },
    {
        path: '/fangzheng',
        component: () => import('@/views/kl/screen/modules/fangzheng/fangzheng.vue'),
        hidden: true,
        name: "fangzhengOne",
        meta: { title: '方正证券大屏', dictType: "fangzheng", affix: false }
    },
    {
        path: '/haiTong',
        component: () => import('@/views/kl/screen/modules/fangzheng/haiTong.vue'),
        hidden: true,
        name: "haiTong",
        meta: { title: '海通证券大屏', dictType: "haiTong", affix: false }
    },
    {
        path: '/cangHaiGongYuan',
        component: () => import('@/views/kl/screen/modules/cangHaiGongYuan/cangHaiGongYuan.vue'),
        hidden: true,
        name: "cangHaiGongYuan",
        meta: { title: '沧海湿地公园', dictType: "cangHaiGongYuan_loadCarrying", affix: false }
    },
    {
        path: '/fangZaiXueYuan',
        component: () => import('@/views/kl/screen/modules/fangZaiXueYuan/fangZaiXueYuan.vue'),
        hidden: true,
        name: "fangZaiXueYuan",
        meta: { title: '防灾科技学院', dictType: "fangZaiXueYuan", affix: false }
    },
    {
        path: '/haGongDa',
        component: () => import('@/views/kl/screen/modules/haGongDa/haGongDa.vue'),
        hidden: true,
        name: "haGongDa",
        meta: { title: '哈工大数据大屏', dictType: "haGongDa", affix: false }
    },
    {
        path: '/si-nan-gong-guan',
        component: () => import('@/views/kl/screen/modules/siNanGongGuan/si-nan-gong-guan.vue'),
        hidden: true,
        name: "si-nan-gong-guan",
        meta: { title: '思南公馆', dictType: "si-nan-gong-guan", affix: false }
    },
    {
        path: '/xiangGangHuoDong',
        component: () => import('@/views/kl/screen/modules/xiangGangHuoDong/xiangGangHuoDong.vue'),
        hidden: true,
        name: "xiangGangHuoDong",
        meta: { title: '香港活动', dictType: "xiangGangHuoDong", affix: false }
    },
]
